/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Horizontal_Padding_HelpInputs */

const en_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left/right screen padding (0-50%)`)
};

const fr_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marge gauche/droite de l'écran (0-50%)`)
};

const de_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linker/rechter Bildschirmabstand (0-50%)`)
};

const it_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaziatura schermo sinistra/destra (0-50%)`)
};

const ru_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отступы слева/справа на экране (0-50%)`)
};

const es_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relleno de pantalla izquierda/derecha (0-50%)`)
};

const zh_cn2_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屏幕左右边距（0-50%）`)
};

const ja_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面の左/右の余白（0～50%）`)
};

const hi_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रीन के बाएँ/दाएँ भाग में पैडिंग (0-50%)`)
};

const pt_pt2_options_display_horizontal_padding_help = /** @type {(inputs: Options_Display_Horizontal_Padding_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preenchimento lateral da tela (0-50%)`)
};

/**
* | output |
* | --- |
* | "Left/right screen padding (0-50%)" |
*
* @param {Options_Display_Horizontal_Padding_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_horizontal_padding_help = /** @type {((inputs?: Options_Display_Horizontal_Padding_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Horizontal_Padding_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_horizontal_padding_help(inputs)
	if (locale === "de") return de_options_display_horizontal_padding_help(inputs)
	if (locale === "it") return it_options_display_horizontal_padding_help(inputs)
	if (locale === "ru") return ru_options_display_horizontal_padding_help(inputs)
	if (locale === "es") return es_options_display_horizontal_padding_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_horizontal_padding_help(inputs)
	if (locale === "ja") return ja_options_display_horizontal_padding_help(inputs)
	if (locale === "hi") return hi_options_display_horizontal_padding_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_horizontal_padding_help(inputs)
	return en_options_display_horizontal_padding_help(inputs)
});